import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EditedPoint } from '../../../../../../interfaces/edit-route.interface';
import { PlannerDayStateService } from 'src/app/pages/custom-route/shared/planner/services';
import { DatePipe } from '@angular/common';
import { DurationPipe } from 'src/app/pipes/duration.pipe';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    TranslateModule,
    DatePipe,
    DurationPipe,
  ],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
  public point = input.required<EditedPoint>();
  
  private _plannerDayStateService = inject(PlannerDayStateService);

  protected  dayToShowIndex = this._plannerDayStateService.dayToShowIndex;
}
